var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      name: "name",
      required: "",
      placeholder: "Name"
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Scheme",
      prop: "schemeId"
    }
  }, [_c("el-select", {
    attrs: {
      name: "schemeId",
      filterable: "",
      clearable: "",
      "default-first-option": "",
      placeholder: "Select Scheme",
      disabled: _vm.isReadOnly || _vm.isEdit && !!_vm.formData.schemeId
    },
    model: {
      value: _vm.formData.schemeId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "schemeId", $$v);
      },
      expression: "formData.schemeId"
    }
  }, _vm._l(_vm.schemes, function (scheme) {
    return _c("el-option", {
      key: scheme.id,
      attrs: {
        value: scheme.id,
        label: scheme.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Dealers Role"
    }
  }, [_c("el-select", {
    attrs: {
      name: "selectedDealersRole",
      filterable: "",
      clearable: "",
      "default-first-option": "",
      placeholder: "Select Dealers Role",
      disabled: _vm.isReadOnly
    },
    on: {
      change: _vm.handleDealersRoleChange
    },
    model: {
      value: _vm.selectedDealersRole,
      callback: function ($$v) {
        _vm.selectedDealersRole = $$v;
      },
      expression: "selectedDealersRole"
    }
  }, _vm._l(_vm.dealersRoles, function (dealersRole) {
    return _c("el-option", {
      key: dealersRole.id,
      attrs: {
        value: dealersRole.id,
        label: dealersRole.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Select Products",
      prop: "product"
    }
  }, [_c("el-select", {
    attrs: {
      name: "selectedProduct",
      "remote-method": _vm.getProducts,
      filterable: "",
      clearable: "",
      "default-first-option": "",
      remote: "",
      multiple: "",
      placeholder: "Type product name",
      disabled: _vm.isReadOnly
    },
    on: {
      change: _vm.handleProductChange
    },
    model: {
      value: _vm.selectedProducts,
      callback: function ($$v) {
        _vm.selectedProducts = $$v;
      },
      expression: "selectedProducts"
    }
  }, _vm._l(_vm.products, function (product) {
    return _c("el-option", {
      key: product.id,
      attrs: {
        value: product.id,
        label: product.name
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };